import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import Icon from "../../assets/Icon";
import { Container } from "./styles";

type Props = {
  onClose?: () => void;
};
const CloseButton: React.FC<Props> = ({ onClose }) => {
  const theme = useContext(ThemeContext);

  return (
    <Container onClick={onClose}>
      <Icon icon={"cross"} size={20} color={theme.colors.primaryText} />{""}Fechar
    </Container>
  );
};

export default CloseButton;
